import React from 'react';
import { FormProvider } from 'forms';
import { SalaryStructureFormData } from 'components/SalaryStructures/creation/types';
import { RearchSalaryStructureForm } from './components/RearchSalaryStructureForm';

export const RearchSalaryStructure = () => {
  return (
    <FormProvider initialState={{ isEditTemplateMode: true } as SalaryStructureFormData}>
      <RearchSalaryStructureForm />
    </FormProvider>
  );
};
